import '.././App.css';
import '../Styles/MainPage.css';

import BannerDev from '../Images/SphereBanners/development.png';
import Banner2D from '../Images/SphereBanners/2dArt.png';
import Banner3D from '../Images/SphereBanners/3dArt.png';

function MainPage({
    changePage
}) {

    return (
        <>


            <div className="nameContainer">
                <div>
                    <h1>Alexey Koval</h1>
                    <h2>Software engineer<br className="visible-tablet"/> <span className="hidden-tablet">&#160; {'&'} &#160;</span> Digital artist</h2>
                </div>
                <p>Dream like a child.&#160;&#160;<br className="visible-tablet"/> Work hard.&#160;&#160;<br className="visible-tablet"/> Create masterpieces.</p>
            </div>



            <div className="mainPageContentElement">
                <div className="textContainer">
                    <h1>Games and Apps</h1>
                    <div className="description">
                        List of games and applications, that are developed by me. Products are available for Android devices and can be downloaded from PlayMarket.
                        <br/><br/>
                        Skills and known technologies:
                        <ul>
                            <li>Java(Android)</li>
                            <li>JavaScript(React)</li>
                            <li>Unreal Engine 4 CPP/BP</li>
                        </ul>
                    </div>
                    <button onClick={() => changePage('dev')}>View more</button>
                </div>
                <div className="imageContainer">
                    <img src={BannerDev} className="hidden-mobile" alt="Icon: development"/>
                </div>            
            </div>   
            <div className="mainPageContentElement solid">
                <div className="textContainer">
                    <h1>2D Art {'&'} Assets</h1>
                    <div className="description">
                        Artworks that are created in combination of traditional and digital art, photographies, etc.
                        <br/><br/>
                        Skills and known technologies:
                        <ul>
                            <li>Basic understanding of design principles</li>
                            <li>Paint Tool SAI</li>
                            <li>Adobe Photoshop</li>
                        </ul>
                    </div>
                    <button onClick={() => changePage('2d')}>View more</button>
                </div>
                <div className="imageContainer">
                    <img src={Banner2D} className="hidden-mobile" alt="Icon: 2d art"/>
                </div>            
            </div>            
            <div className="mainPageContentElement">
                <div className="textContainer">
                    <h1>3D Art {'&'} Assets</h1>
                    <div className="description">
                        3D Artworks in such styles as lowpoly and semirealism. Also 3D assets, that are available for commertial use.
                        <br/><br/>
                        Skills and known technologies:
                        <ul>
                            <li>Blender 2.8+</li>
                            <li>Complete character creation workflow</li>
                            <li>Environment creation</li>
                            <li>Procedural maerials (blender)</li>
                        </ul>
                    </div>
                    <button onClick={() => changePage('3d')}>View more</button>
                </div>
                <div className="imageContainer">
                    <img src={Banner3D} className="hidden-mobile" alt="Icon: 3d art"/>
                </div>            
            </div>                              
        </>
    );

}

export default MainPage;